import { inject, Injectable, Injector } from '@angular/core';
import { IonNav, ModalController } from '@ionic/angular/standalone';
import { BreakpointService } from '@marineform/fe-util';
import { AnimationsService } from '@marineform/ssc-ui';
import { MODULE_STORE, ModuleAction } from '@marineform/manage-data-access';
import { RecordMenuComponent } from '../components/shared/record-menu/record-menu.component';

export type RecordMenuOpenOptions = {
  injector: Injector;
  nav?: IonNav;
  onLoading?: (loading: boolean) => void;
  onRecordGone?: () => void;
};

@Injectable({ providedIn: 'root' })
export class RecordMenuService {
  #modalCtrl = inject(ModalController);
  #animations = inject(AnimationsService);
  #breakpoints = inject(BreakpointService);

  async open(options: RecordMenuOpenOptions): Promise<void> {
    const { injector, nav, onLoading, onRecordGone } = options;
    const store = injector.get(MODULE_STORE);
    const isTablet = this.#breakpoints.isTablet();

    const modal = await this.#modalCtrl.create({
      mode: 'ios',
      component: RecordMenuComponent,
      injector,
      cssClass: isTablet ? 'side-modal' : 'bottom-record-modal',
      breakpoints: isTablet ? undefined : [0, 0.75, 1],
      initialBreakpoint: isTablet ? undefined : 0.75,
      enterAnimation: isTablet
        ? this.#animations.createSideEnterAnimation()
        : undefined,
      leaveAnimation: isTablet
        ? this.#animations.createSideLeaveAnimation()
        : undefined,
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    const moduleAction = data as ModuleAction | undefined;
    if (!moduleAction) {
      return;
    }

    // Dynamic import avoids RecordMenuService → executeModuleAction → NestedArea → RecordMenuService.
    const { executeModuleAction } = await import(
      '../navigation/execute-module-action'
    );
    executeModuleAction(moduleAction, {
      store,
      nav,
      injector,
      onLoading,
      onRecordGone,
    });
  }
}
